var getIdFromUrl = function(videoUrl) {
   var videoIdRegex = /(youtu\.be\/|v=)(.{11})/i;
   var videoIdMatch = videoIdRegex.exec(videoUrl);
   return videoIdMatch && videoIdMatch[2] ? videoIdMatch[2] : '*';
};

export default {
   getIdFromUrl: getIdFromUrl
};
